"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "PageContent", {
  enumerable: true,
  get: function get() {
    return _pageContent["default"];
  }
});
Object.defineProperty(exports, "WrapperContext", {
  enumerable: true,
  get: function get() {
    return _wrapperContext["default"];
  }
});
Object.defineProperty(exports, "DrawerContext", {
  enumerable: true,
  get: function get() {
    return _drawerContext["default"];
  }
});
Object.defineProperty(exports, "AccountContext", {
  enumerable: true,
  get: function get() {
    return _accountContext["default"];
  }
});
exports.Navigation = exports.checkForEquality = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _isEqual = _interopRequireDefault(require("lodash/isEqual"));

var _actionButton = _interopRequireDefault(require("./components/action-button"));

var _backButton = _interopRequireDefault(require("./components/back-button"));

var _brandLogo = _interopRequireDefault(require("./components/brand-logo"));

var _hamburgerMenu = _interopRequireDefault(require("./components/hamburger-menu"));

var _closeFocusButton = _interopRequireDefault(require("./components/close-focus-button"));

var _breadCrumbs = _interopRequireDefault(require("./components/bread-crumbs"));

var _drawer = _interopRequireDefault(require("./components/drawer"));

var _tabs = _interopRequireDefault(require("./components/tabs"));

var _searchBar = _interopRequireDefault(require("./components/search-bar"));

var _divider = _interopRequireDefault(require("./components/divider"));

var _accountBox = _interopRequireDefault(require("./components/account-box"));

var _rightContentDrawer = _interopRequireDefault(require("./components/right-content-drawer"));

var _inlineContentDrawer = _interopRequireDefault(require("./components/inline-content-drawer"));

var _fullAlign = _interopRequireDefault(require("./components/full-align"));

var _supportMode = _interopRequireDefault(require("./components/support-mode"));

var _helpButton = _interopRequireDefault(require("./components/help-button"));

var _spacer = _interopRequireDefault(require("./components/spacer"));

var _siteSelector = _interopRequireDefault(require("./components/site-selector"));

var _businessSelector = _interopRequireDefault(require("./components/business-selector"));

var _pageContent = _interopRequireDefault(require("./components/page-content"));

var _detailBar = _interopRequireDefault(require("./components/detail-bar"));

var _wrapperContext = _interopRequireDefault(require("./context/wrapper-context"));

var _drawerContext = _interopRequireDefault(require("./context/drawer-context"));

var _accountContext = _interopRequireDefault(require("./context/account-context"));

var _reactRouter = require("react-router");

require("./style/wrapper.scss");

require("./style/navbar.scss");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _templateObject3() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  flex: 1;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  overflow: hidden;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  display: flex;\n  align-items: center;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var LeftAlign = _styledComponents["default"].div(_templateObject());

var RightAlign = _styledComponents["default"].div(_templateObject2());
/**
 * Required when using LeftAlign or RightAlign
 */


var CenterAlign = _styledComponents["default"].div(_templateObject3());

var checkForEquality = function checkForEquality() {
  for (var _len = arguments.length, params = new Array(_len), _key = 0; _key < _len; _key++) {
    params[_key] = arguments[_key];
  }

  return params.some(function (param) {
    return !(0, _isEqual["default"])(param[0], param[1]);
  });
};

exports.checkForEquality = checkForEquality;

var Navigation = /*#__PURE__*/function (_Component) {
  (0, _inherits2["default"])(Navigation, _Component);

  var _super = _createSuper(Navigation);

  function Navigation() {
    var _this;

    (0, _classCallCheck2["default"])(this, Navigation);

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.state = {
      subPages: [],
      drawerIsOpen: _this.props.initialDrawerStateOpen,
      currentTab: 0,
      currentDrawerItem: null,
      amountOfDetailBars: 0
    };

    _this.incrementAmountOfDetailBars = function () {
      _this.setState(function (_ref) {
        var amountOfDetailBars = _ref.amountOfDetailBars;
        return {
          amountOfDetailBars: amountOfDetailBars + 1
        };
      });

      return function () {
        _this.setState(function (_ref2) {
          var amountOfDetailBars = _ref2.amountOfDetailBars;
          return {
            amountOfDetailBars: amountOfDetailBars - 1
          };
        });
      };
    };

    return _this;
  }

  (0, _createClass2["default"])(Navigation, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var _this$props = this.props,
          features = _this$props.features,
          authenticationMethod = _this$props.authenticationMethod;
      var accountType = this.props.accountType;

      if (accountType && accountType.toLowerCase() !== 'builder' && authenticationMethod && authenticationMethod.toLowerCase() === 'logintoken') {
        // When a support agent is logged in (we can identify that by looking at authentication method), force the accounttype to builder
        // Need to find better solution for this with the backend
        accountType = 'Builder';
      }

      try {
        if (window.localStorage && window.localStorage.setItem) {
          if (features) {
            window.localStorage.setItem('account_features', JSON.stringify(features));
          }

          if (accountType) {
            window.localStorage.setItem('account_type', accountType);
          }
        }
      } catch (err) {
        console.log('localstorage not supported');
      }

      if (features || accountType) {
        window.setItemsInTheLeftMenu && window.setItemsInTheLeftMenu(features, accountType);
      }
    }
  }, {
    key: "closeFocusView",
    value: function closeFocusView() {
      var func = this.props.closeFocusView;

      if (!func) {
        console.error('closeFocusView property is missing in navigation component');
      } else {
        func();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          children = _this$props2.children,
          isFocusView = _this$props2.isFocusView,
          hideNavBar = _this$props2.hideNavBar;
      var _this$state = this.state,
          currentTab = _this$state.currentTab,
          currentDrawerItem = _this$state.currentDrawerItem,
          subPages = _this$state.subPages,
          amountOfDetailBars = _this$state.amountOfDetailBars;

      if (this.props.userEmail) {
        Navigation.removeFakeNavigation();
      }

      return /*#__PURE__*/_react["default"].createElement(_wrapperContext["default"].Provider, {
        value: {
          isFreeAccount: this.props.isFreeAccount,
          userFullName: this.props.userFullName,
          userEmail: this.props.userEmail,
          userColor: this.props.userColor,
          authenticationMethod: this.props.authenticationMethod,
          breadCrumb: this.props.breadCrumb,
          activePage: this.props.activePage,
          location: this.props.location,
          history: this.props.history,
          match: this.props.match,
          tabs: subPages.map(function (page) {
            return {
              label: page.title,
              path: page.path,
              key: page.title,
              location: page.location
            };
          }) || [],
          hideBackButton: this.props.hideBackButton,
          drawerIsOpen: this.state.drawerIsOpen,
          closeFocusView: function closeFocusView() {
            return _this2.closeFocusView();
          },
          toggleDrawer: function toggleDrawer(bool) {
            _this2.setState({
              drawerIsOpen: typeof bool === 'boolean' ? bool : !_this2.state.drawerIsOpen
            });
          },
          isFocusView: isFocusView,
          hideNavBar: hideNavBar,
          incrementAmountOfDetailBars: this.incrementAmountOfDetailBars,
          amountOfDetailBars: amountOfDetailBars,
          currentTab: currentTab || 0,
          currentDrawerItem: currentDrawerItem || null,
          setCurrentTab: function setCurrentTab(index) {
            return _this2.setState({
              currentTab: index
            });
          },
          setCurrentDrawerItem: function setCurrentDrawerItem(item) {
            return _this2.setState({
              currentDrawerItem: item
            });
          }
        }
      }, children);
    }
  }], [{
    key: "removeFakeNavigation",
    value: function removeFakeNavigation() {
      var fakeNav = document.getElementById('fake-nav');

      if (fakeNav) {
        // fakeNav.remove() --> Not supported in IE11
        fakeNav.parentNode.removeChild(fakeNav);
      }
    }
  }, {
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      var previousSubs = prevState.subPages;
      var nextSubs = nextProps.activePage && nextProps.activePage.subPages; // Note you have to check if location changed to be sure that the right tab will be selected ui wise, on browser back and forward.

      if (previousSubs !== nextSubs || nextProps.location !== prevState.location) {
        var subPages = nextProps.activePage && nextProps.activePage.subPages || [];
        var currentTabIndex = 0;
        subPages.forEach(function (subPage, index) {
          var match = (0, _reactRouter.matchPath)(nextProps.location.pathname, subPage);

          if (match) {
            currentTabIndex = index;
          }
        });
        return {
          subPages: subPages,
          currentTab: currentTabIndex,
          location: nextProps.location
        };
      }

      return null;
    }
  }]);
  return Navigation;
}(_react.Component);

exports.Navigation = Navigation;
Navigation.propTypes = {
  children: _propTypes["default"].oneOfType([_propTypes["default"].node, _propTypes["default"].arrayOf(_propTypes["default"].node)]),
  activePage: _propTypes["default"].object.isRequired,
  isFocusView: _propTypes["default"].bool,
  hideBackButton: _propTypes["default"].bool,
  breadCrumb: _propTypes["default"].array,
  hideNavBar: _propTypes["default"].bool,
  closeFocusView: _propTypes["default"].func,
  userFullName: _propTypes["default"].string,
  userEmail: _propTypes["default"].string,
  userColor: _propTypes["default"].string,
  location: _propTypes["default"].object,
  history: _propTypes["default"].object,
  match: _propTypes["default"].object,
  isFreeAccount: _propTypes["default"].bool,
  initialDrawerStateOpen: _propTypes["default"].bool,
  features: _propTypes["default"].any,
  accountType: _propTypes["default"].string,
  authenticationMethod: _propTypes["default"].string
};
Navigation.BrandLogo = _brandLogo["default"];
Navigation.HamburgerMenu = _hamburgerMenu["default"];
Navigation.BreadCrumbs = _breadCrumbs["default"];
Navigation.ActionButton = _actionButton["default"];
Navigation.Tabs = _tabs["default"];
Navigation.SearchBar = _searchBar["default"];
Navigation.BackButton = _backButton["default"];
Navigation.LeftAlign = LeftAlign;
Navigation.RightAlign = RightAlign;
Navigation.CenterAlign = CenterAlign;
Navigation.DetailBar = _detailBar["default"];
Navigation.Drawer = _drawer["default"];
Navigation.Divider = _divider["default"];
Navigation.AccountBox = _accountBox["default"];
Navigation.CloseFocusButton = _closeFocusButton["default"];
Navigation.RightContentDrawer = _rightContentDrawer["default"];
Navigation.LeftContentDrawer = _inlineContentDrawer["default"];
Navigation.FullAlign = _fullAlign["default"];
Navigation.SupportMode = _supportMode["default"];
Navigation.HelpButton = _helpButton["default"];
Navigation.SiteSelector = _siteSelector["default"];
Navigation.Spacer = _spacer["default"];
Navigation.BusinessSelector = _businessSelector["default"];